<template>
	<div>
		<Datatable :headers="headers" :items="items" title="Service Descriptions" item-slot="item.is_template"
							 :loading="$store.state.details.fetching.services"
							 @click:row="openEditDialog($event)"
							 @click:edit="openEditDialog($event)"
							 @click:delete="openEditDialog($event, 'delete')"
		>
			<template #top>
				<Button icon="mdi-plus" :color="ada.blue" @click="openEditDialog(null)">Add Service</Button>
			</template>
			<template #[`item.is_template`]=" item ">
				<v-icon :color="item?.is_template === 1 ? 'green' : ada.grey"
				>
					{{ item?.is_template === 1 ? 'mdi-check' : 'mdi-close' }}
				</v-icon>
			</template>
		</Datatable>
		<DialogCustom v-model="showEditDialog" :title="selected.id ? 'Edit service' : 'Add service'"
									:loading="loading.submit"
									@ok="submit"
									@cancel="showEditDialog = false">
			<v-form v-model="valid" ref="form">
				<v-switch v-model="selected.is_template" :true-value="1" :false-value="0" :color="ada.pink">
					<template #label>
						<div class="mr-2">Is a template</div>
						<TooltipIcon :color="ada.grey"
												 tooltip="Templates will be shown as a default dropdown option">
							mdi-information
						</TooltipIcon>
					</template>
				</v-switch>
				<Input label="Name" v-model="selected.name" @enter="submit"></Input>
			</v-form>
		</DialogCustom>

		<!-- CONFIRM DELETE DIALOG-->
		<DialogCustom v-model="showDeleteDialog" title="Delete service description" ok-text="Yes, Delete"
									:loading="loading.delete" width="400px" min-width="400px"
									@ok="deleteService" @cancel="showDeleteDialog = false">
			<p>Are you sure that you want to delete the following service description ?</p>
			<p class="d-flex justify-center"><b>{{ selected ? selected.name : '' }}</b></p>
		</DialogCustom>
	</div>
</template>

<script>
import ada from '@/scripts/adaColors';
import Datatable from "../../../components/Tables/Datatable";
import Button from "../../../components/buttons/Button";
import DialogCustom from "../../../components/DialogCustom.vue";
import Input from "../../../components/Inputs/Input";
import TooltipIcon from "../../../components/buttons/TooltipIcon";

export default {
	name: "Settings_Services",
	components: {TooltipIcon, Input, DialogCustom, Button, Datatable},
	data: () => ({
		ada,
		headers: [
			{text: 'Is template', value: 'is_template', width: '120px', align: 'center'},
			{text: 'Name', value: 'name'},
			{text: 'Created at', value: 'created_at', width: '200px'},
			{text: 'Actions', value: 'action', width: '100px'},
		],
		valid: null,
		showEditDialog: false,
		showDeleteDialog: false,
		selected: {
			name: null,
			is_template: 1
		},
		loading: {
			submit: false,
			delete: false,
		},
		filter: [
			{text: 'Template', value: 1},
			{text: 'No template', value: 0},
		],
		selectedFilter: [],
	}),
	mounted() {
		this.init()
	},
	computed: {
		items() {
			let ret = [];
			let options = {year: 'numeric', month: '2-digit', day: '2-digit'};
			this.$store.state.details.services.forEach((item) => {
				item.createdFormatted = new Date(item.created_at).toLocaleDateString('de-DE', options);
				item.action = ['edit', 'delete'];
				ret.push(item);
			});
			return this.selectedFilter.length !== 0 ? ret.filter(x => this.selectedFilter.includes(x.is_template)) : ret;
		},
		error() {
			return this.$store.state.errorCount;
		}
	},
	methods: {
		init() {
			if (this.items.length === 0) this.fetch();
		},
		async fetch() {
			await this.$store.dispatch('details/fetchServices');
		},
		async submit() {
			await this.$refs.form.validate();
			if (this.valid) {
				this.loading.submit = true;
				const res = await this.$store.dispatch('details/updateService', this.selected);
				if (res && res !== "") {
					this.$root.$emit('snackbar', 'Successfully saved');
					this.showEditDialog = false;
				}

				this.loading.submit = false;
			}
		},
		async deleteService() {
			this.loading.delete = true;
			const res = await this.$store.dispatch('details/deleteService', this.selected.id);
			if (res && res !== "") {
				this.$root.$emit('snackbar', 'Successfully deleted ' + this.selected.name);
				if (this.showEditDialog) this.showEditDialog = false;
				this.showDeleteDialog = false;
			}
			this.loading.delete = false;
		},
		openEditDialog(data, type = 'edit') {
			if (data) this.selected = JSON.parse(JSON.stringify(data));
			if (type === 'delete') this.showDeleteDialog = true;
			if (type === 'edit') this.showEditDialog = true;
		}
	},
	watch: {
		showEditDialog(v) {
			if (!v) {
				this.selected = {
					name: null,
					is_template: 1
				};
			}
		},
		showDeleteDialog(v) {
			if (!v) {
				this.selected = {
					name: null,
					is_template: 1
				};
			}
		},
		error() {
			if (this.loading.submit) this.loading.submit = false;
			if (this.loading.delete) this.loading.delete = false;
		}
	}
}
</script>

<style scoped>

</style>